import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Hero from '../components/Hero';
import { FaCode, FaLaptop, FaMobileAlt } from 'react-icons/fa';

const Home = () => {
  const features = [
    {
      icon: <FaCode />,
      title: "Web Development",
      description: "Building responsive and interactive web applications using modern technologies."
    },
    {
      icon: <FaLaptop />,
      title: "IT Student",
      description: "Currently pursuing BSc IT at Thakur College, exploring new technologies."
    },
    {
      icon: <FaMobileAlt />,
      title: "Responsive Design",
      description: "Creating websites that work seamlessly across all devices."
    }
  ];

  return (
    <HomeContainer>
      <Hero />
      
      <FeaturesSection>
        <SectionTitle
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          What I Do
        </SectionTitle>
        
        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              whileHover={{ y: -10 }}
            >
              <IconWrapper>{feature.icon}</IconWrapper>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeaturesGrid>
      </FeaturesSection>

      <LatestSection>
        <SectionTitle
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Latest Updates
        </SectionTitle>
        <UpdatesGrid>
          <UpdateCard
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <UpdateDate>Current</UpdateDate>
            <UpdateTitle>BSc IT Student</UpdateTitle>
            <UpdateDescription>
              Studying Information Technology at Thakur College of Science and Commerce
            </UpdateDescription>
          </UpdateCard>
          <UpdateCard
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <UpdateDate>Latest</UpdateDate>
            <UpdateTitle>Portfolio Development</UpdateTitle>
            <UpdateDescription>
              Building and enhancing my portfolio with React and modern web technologies
            </UpdateDescription>
          </UpdateCard>
        </UpdatesGrid>
      </LatestSection>
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  min-height: 100vh;
`;

const FeaturesSection = styled.section`
  padding: 100px 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled(motion.h2)`
  font-size: 2.5rem;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 50px;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  padding: 0 20px;
`;

const FeatureCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const IconWrapper = styled.div`
  font-size: 2.5rem;
  color: var(--accent);
  margin-bottom: 1rem;
`;

const FeatureTitle = styled.h3`
  color: var(--text-primary);
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const FeatureDescription = styled.p`
  color: var(--text-secondary);
  line-height: 1.6;
`;

const LatestSection = styled.section`
  padding: 100px 20px;
  background: rgba(255, 255, 255, 0.02);
`;

const UpdatesGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 0 20px;
`;

const UpdateCard = styled(motion.div)`
  background: var(--background);
  padding: 2rem;
  border-radius: 10px;
  border: 1px solid var(--accent);
`;

const UpdateDate = styled.span`
  color: var(--accent);
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 0.9rem;
`;

const UpdateTitle = styled.h3`
  color: var(--text-primary);
  font-size: 1.5rem;
  margin: 1rem 0;
`;

const UpdateDescription = styled.p`
  color: var(--text-secondary);
  line-height: 1.6;
`;

export default Home;